<template>
  <!--右侧悬浮框-->
  <div class="rightFlex-main">
    <!--右侧悬浮框-->
    <div id="floorRight" class="floorRight">
      <div class="toolkit-list">
        <div class="toolkit-item-new">
          <router-link class="a_link" to="/">
            <i class="toolkit-icon" style="background-image: url('/static/img/new/tps-96-96.png');"></i>
            <span class="toolkit-label">首页</span>
          </router-link>
        </div>
        <div class="toolkit-item-new">
          <router-link @click="saveLine(5, '购物车')" class="a_link" to="/ShopCart">
            <div class="toolkit-icon">
              <img src="/static/img/new/shopcart.png" alt="" class="im-icon-new">
              <div v-if="cartCount > 0" class="im-num-new">{{ cartCount }}</div>
            </div>
            <span class="toolkit-label">购物车</span>
          </router-link>
        </div>
        <el-tooltip placement="left" effect="light">
          <div slot="content" class="call-num">
            <p class="call-img">
              <img src="/static\img\index\img\分组 8.png" alt="" />
            </p>
            <p class="call-txt">全国热线电话</p>
            <p class="call-line"></p>
            <p class="call-phoneNum">0772-2082592</p>
            <!-- <span class="call-icon"></span>-->
          </div>
        <div class="toolkit-item-new">
          <div class="a_link">
            <i class="toolkit-icon" style="background-image: url('/static/img/new/kefu.png');"></i>
            <span class="toolkit-label">在线客服</span>
          </div>
        </div>
        </el-tooltip>
        <div class="toolkit-item-new">
          <router-link @click="saveLine(5, '我的收藏')" class="a_link" to="/personal/Favorites">
            <i class="toolkit-icon" style="background-image: url('/static/img/new/sc.png');"></i>
            <span class="toolkit-label">我的收藏</span>
          </router-link>
        </div>
        <div class="toolkit-item-new">
          <router-link  class="a_link" to="/personal/MyMessages">
            <i class="toolkit-icon" style="background-image: url('/static/img/new/message.png');"></i>
            <span class="toolkit-label">消息</span>
          </router-link>
        </div>
        <div class="toolkit-item-new">
          <router-link  @click="saveLine(5, '我的订单')"  class="a_link" to="/personal/MyOrder">
            <i class="toolkit-icon" style="background-image: url('/static/img/new/order.png');"></i>
            <span class="toolkit-label">我的订单</span>
          </router-link>
        </div>
        <div class="toolkit-item-new">
          <router-link   class="a_link" to="/personal/Purchase">
            <i class="toolkit-icon" style="background-image: url('/static/img/new/zncg.png');"></i>
            <span class="toolkit-label">智能采购</span>
          </router-link>
        </div>
        <div class="toolkit-item-new">
          <router-link   class="a_link" to="/personal/UserFeedback">
            <i class="toolkit-icon" style="background-image: url('/static/img/new/fk.png');"></i>
            <span class="toolkit-label">反馈</span>
          </router-link>
        </div>
      </div>
      <ul class="floorRight-ul">

      </ul>

    </div>
    <!--右侧悬浮框-->

  </div>
</template>

<script>
import store from "@/vuex/store";
import { mapGetters } from "vuex";
import "swiper/dist/css/swiper.min.css";
import { isEmpty } from "@/utils";
import { lineLocal } from '@/api/apiPot.js'
export default {
  name: "RightFlex",
  data() {
    return {
      setIntervalObj: null,
      setIntervalWeekly: null,
      value2: 0,
      sideCart: false,
      cartCount: 0, //购物车角标数量
      favoritesCount: 0, //收藏角标数量
      messageCount: 0, //购信息角标数量
      cartList: [], //购物车
      skillList: [], //秒杀购物车
      delIds: "",
      delType: 1,
      delVisible: false,
      zoneGiftsList: [] //专区赠品列表
    };
  },
  computed: {
    ...mapGetters(["rightRefresh", "shoppingCart"]),
    userName() {
      return store.state.tokens;
    }
  },
  watch: {
    rightRefresh: {
      handler(newVal, oldVal) {
        this.rightNum();
      }
    },
    shoppingCart: {
      handler(newVal, oldVal) {
        this.rightNum();
      },
      deep: true
    }
  },
  mounted() {
    /*右侧悬浮框效果*/
    // 有token的情况下直接调购物车，没token直接获取角标  因为购物车调用时会自动刷新一遍角标
    if (isEmpty(this.userName)) {
      this.rightNum();
    }
  },
  methods: {
    saveLine(t, s) {
      lineLocal({ source_type: t, source_info: s })
    },

    rightNum() {
      /**右侧角标数量 */
      this.$https
        .get("/GoodsCart/cart_count")
        .then(res => {
          this.cartCount = res.data.num;
        })

    },
  },
  store
};
</script>

<style lang="less" scoped>
.rightFlex-main {}

.floorRight {
  position: fixed;
  right: 0;
  bottom: 50%;
  -webkit-transform: translateY(50%);
  -moz-transform: translateY(50%);
  -ms-transform: translateY(50%);
  -o-transform: translateY(50%);
  transform: translateY(50%);
  z-index: 999;
  background-color: #fff;
  border-radius: 12px 0 0 12px;
  width: 56px;
  border-width: 1px 0px 1px 1px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.08);



  .floorRight-ul li:hover .floorRight-txt {
    color: #629812;
  }




}

/*右侧固定购物车*/

.toolkit-list{
  padding: 4px;
}
.toolkit-item-new{
  position: relative;
  text-align: center;
  width: 48px;
  height: 48px;
  margin-top: 8px;
  z-index: 1;
  cursor: pointer;
}
.toolkit-item-new:hover {
  background: rgba(0, 0, 0, 0.04);
  border-radius: 8px;
}
.toolkit-item-new:first-child {
  margin-top: 0;
}
.toolkit-item-new .a_link {
  display: block;
  text-decoration: none;
}
.toolkit-icon {
  display: block;
  width: 24px;
  height: 24px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin-left: 12px;
  padding-top: 4px;
  box-sizing: content-box;
}
.toolkit-label {
  display: block;
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  color: #1f1f1f;
  padding-bottom: 6px;
}
.im-icon-new {
  width: 24px;
  object-fit: contain;
}
.im-num-new {
  position: absolute;
  top: 0;
  left: 25px;
  font-size: 10px;
  font-family: inter;
  height: 14px;
  line-height: 14px;
  min-width: 14px;
  font-weight: 500;
  background-color: #ff5000;
  color: #fff;
  padding: 0 3px;
  border-radius: 1000px;
  white-space: nowrap;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/RightFlex.vue